import * as React from "react";
import type { SVGProps } from "react";
const SvgInfrastructure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.119 4.373H2.076a.25.25 0 0 0-.25.25v10.474c0 .138.112.25.25.25h51.043a.25.25 0 0 0 .25-.25V4.623a.25.25 0 0 0-.25-.25ZM2.076 2.623a2 2 0 0 0-2 2v10.474a2 2 0 0 0 2 2h51.043a2 2 0 0 0 2-2V4.623a2 2 0 0 0-2-2H2.076Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.145 11.54a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86ZM16.936 11.54a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M23.496 9.896c0-.69.56-1.25 1.25-1.25h14.85a1.25 1.25 0 1 1 0 2.5h-14.85c-.69 0-1.25-.56-1.25-1.25ZM43.1 9.86c0-.69.56-1.25 1.25-1.25h4.22a1.25 1.25 0 1 1 0 2.5h-4.22c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.119 20.847H2.076a.25.25 0 0 0-.25.25V31.57c0 .138.112.25.25.25h51.043a.25.25 0 0 0 .25-.25V21.097a.25.25 0 0 0-.25-.25Zm-51.043-1.75a2 2 0 0 0-2 2V31.57a2 2 0 0 0 2 2h51.043a2 2 0 0 0 2-2V21.097a2 2 0 0 0-2-2H2.076Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.145 28.013a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86ZM16.936 28.013a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M23.496 26.37c0-.69.56-1.25 1.25-1.25h14.85a1.25 1.25 0 0 1 0 2.5h-14.85c-.69 0-1.25-.56-1.25-1.25ZM43.1 26.334c0-.69.56-1.25 1.25-1.25h4.22a1.25 1.25 0 1 1 0 2.5h-4.22c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.119 37.32H2.076a.25.25 0 0 0-.25.25v10.474c0 .138.112.25.25.25h51.043a.25.25 0 0 0 .25-.25V37.57a.25.25 0 0 0-.25-.25ZM2.076 35.57a2 2 0 0 0-2 2v10.474a2 2 0 0 0 2 2h51.043a2 2 0 0 0 2-2V37.57a2 2 0 0 0-2-2H2.076Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.145 44.487a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86ZM16.936 44.487a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36Zm0 1.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M23.496 42.843c0-.69.56-1.25 1.25-1.25h13.213a1.25 1.25 0 0 1 0 2.5H24.746c-.69 0-1.25-.56-1.25-1.25ZM43.1 42.807c0-.69.56-1.25 1.25-1.25h4.22a1.25 1.25 0 0 1 0 2.5h-4.22c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M63.924 53.516c0 4.356-3.547 7.861-7.922 7.861h-16.11c-4.39 0-7.922-3.52-7.922-7.861 0-4.356 3.547-7.862 7.922-7.862h.296c.724-3.593 3.916-6.277 7.744-6.277s7.02 2.684 7.745 6.263h.296c4.39 0 7.922 3.52 7.951 7.876Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M40.188 45.654h-.296c-4.375 0-7.922 3.506-7.922 7.862 0 4.341 3.533 7.861 7.922 7.861h16.11c4.375 0 7.922-3.505 7.922-7.861-.03-4.356-3.562-7.876-7.951-7.876h-.296c-.724-3.579-3.916-6.263-7.745-6.263-3.828 0-7.02 2.684-7.744 6.277Zm1.432 1.75h-1.728c-3.423 0-6.172 2.737-6.172 6.112 0 3.364 2.739 6.111 6.172 6.111h16.11c3.421 0 6.169-2.733 6.172-6.105a6.18 6.18 0 0 0-6.201-6.132h-1.727l-.284-1.403c-.56-2.763-3.034-4.86-6.03-4.86-2.993 0-5.469 2.095-6.029 4.873l-.283 1.404Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfrastructure;
